module.exports = __webpack_public_path__ + "static/media/product13.b7f9c558.jpg";